import styled from 'styled-components';
import space from '../utils/style/space';

/**
 * スタイルを変えたいが時間がかかりそうなのでそのまま
 */
const Checkbox = styled.input`
  &[type='checkbox'] {
    appearance: none;
    outline: none;
    display: block;
    position: relative;
    text-align: center;
    cursor: pointer;
    width: 15px;
    height: 15px;
    margin-right: ${space.xxxs}px;
    &::before {
      display: block;
      position: absolute;
      content: '';
      width: 15px;
      height: 15px;
      background: #fff;
      border: solid 1px #e6e6e6;
      border-radius: 1px;
    }
    &::after {
      display: block;
      content: '';
      position: absolute;
      left: 6px;
      top: 3px;
      width: 4px;
      height: 8px;
      border-right: 2px solid #000;
      border-bottom: 2px solid #000;
      transform: rotate(40deg);
      opacity: 0;
    }
    &:checked::after {
      opacity: 1;
    }
  }
`;

export default Checkbox;
